import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
body {
  margin: 0;
  font-family: 'RoobertEnel', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: ${(p) => p.theme.colors.primary.white}
}

.nav-link.active {
  border-bottom: 2px solid !important;
  border-bottom-color: purple !important;
  background-color: ${(p) => p.theme.colors.primary.white} !important
}

.nav-tabs {
  border: none !important;
  padding-left: 30px;
  padding-right: 30px;
  margin-left: 40px
}

.nav-link {
  border: none !important;
  color: black
}

::-webkit-scrollbar {
  height: 8px !important;
  width: 8px !important;
  background: transparent;
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: ${(p) => p.theme.scrollbar.color};
}

::-webkit-scrollbar-thumb:hover {
  border: 2px solid ${(p) => p.theme.scrollbar.hoverColor};
}
`;

export default GlobalStyle;
